import styled from "styled-components";

interface IVolanteDetailContainer {
  isTotal?: any;
}
export const VolanteDetailContainer = styled.div<IVolanteDetailContainer>`
  ${(props) => {
    let color = props.theme.colors.blackTextTitle;
    let weight = 500;
    if (props.isTotal) {
      weight = 700;
    }
    return `
      color: ${color};
      font-weight: ${weight};
    `;
  }}
  display: grid;
  grid-template-columns: 9fr 2fr 2fr 2fr 2fr 2fr 2fr 0.5fr;
  font-size: 1.4rem;
  padding: 1rem 1.5rem;

  .discount {
    color: ${(props) => props.theme.colors.accentRed};
  }

  .sales-value {
    font-weight: 700;
  }
`;
